/**
 * **Red Roof**
 *
 * @exports partnership_393
 * @category partnerships
 */
function factory({ window, document, thn }) {
    const partnership = {};
    /**
        * @memberOf module:partnership_393
        */
    partnership.getId = function getId() {
        return '393';
    };
    /**
       * @memberOf module:partnership_362
       */
    partnership.boot = function boot() {
        if (!window.dataLayer) {
            return;
        }
        // Unload all datalayer helpers on partnership shutdown
        partnership.shutdown = thn.generateCallbackQueue();
        const refreshPartnership = thn.debounce(thn.siteCheck, 800);
        let dataLayerHelper = new thn.DataLayerHelper(window.dataLayer, function (model, message) {
            if (message.event === 'PageTransition' || message.event === 'locationSearched') {
                refreshPartnership();
            }
        }, true);
        partnership.shutdown = function () {
            dataLayerHelper.unlisten();
            dataLayerHelper = null;
        };
    };
    /**
        * @memberOf module:partnership_393
        */
    partnership.check = function check() {
        const isRedRoof = window.location.hostname.includes('redroof.com');
        return isRedRoof;
    };
    /**
        * @memberOf module:partnership_393
        */
    partnership.getHotelId = function getHotelId() {
        const dataLayer = window.dataLayer;
        // all searched results will be in dataLayer
        const searchedData = dataLayer && [...dataLayer].filter((search) => search?.ecommerce);
        // We have to get the last searched data from dataLayer
        const lastSearchedData = searchedData?.pop();
        const hotelId = thn.parseUrlParameter('DestId') || thn.objectGet(lastSearchedData, 'propertyId');
        const corpoHomepage = window.location.pathname === '/';
        let result;
        if (hotelId && !corpoHomepage) {
            result = {
                partnership_hotel_id: hotelId,
            };
        }
        else {
            result = {
                account_key: 'A8C8BF959B8459820A874F653259576C',
            };
        }
        return result;
    };
    return partnership;
}

export { factory };
